import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import axios from "../../../axios";
import handleApiError from "../../../utils/handleApiError";
import FullPageLoader from "../../components/FullPageLoader";
import ErrorModal from "../../components/ErrorModal";

export default function CategoryEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({ name: "", slug: "", prefix: "" });
  const [subcategories, setSubcategories] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchCategory = async () => {
    try {
      const res = await axios.get(`/admin/categories/${id}`);
      const cat = res.data;
      setForm({ name: cat.name, slug: cat.slug, prefix: cat.prefix });
      setSubcategories(
        cat.sub_categories.map((sub) => ({
          id: sub.id,
          name: sub.name,
          prefix: sub.prefix,
        }))
      );
    } catch (err) {
      setError(handleApiError(err));
    }
  };

  useEffect(() => {
    fetchCategory();
  }, [id]);

  const handleFormChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubChange = (index, field, value) => {
    const updated = [...subcategories];
    updated[index][field] = value;
    setSubcategories(updated);
  };

  const handleAddSub = () => {
    setSubcategories([...subcategories, { name: "", prefix: "" }]);
  };

  const handleRemoveSub = (index) => {
    const updated = subcategories.filter((_, i) => i !== index);
    setSubcategories(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const prefixes = subcategories.map((s) => s.prefix.trim().toLowerCase());
  const hasDuplicate = prefixes.some((p, i) => prefixes.indexOf(p) !== i);
  if (hasDuplicate) {
    setError("Prefix subkategori tidak boleh duplikat.");
    setLoading(false);
    return;
  }
  
    try {
      await axios.put(`/admin/categories/${id}`, form);

      for (const sub of subcategories) {
        if (sub.name && sub.prefix) {
          if (sub.id) {
            await axios.put(`/admin/sub-categories/${sub.id}`, {
              name: sub.name,
              prefix: sub.prefix,
              category_id: id,
            });
          } else {
            await axios.post(`/admin/sub-categories`, {
              name: sub.name,
              prefix: sub.prefix,
              category_id: id,
            });
          }
        }
      }

      navigate(`/admin/categories/${id}`);
    } catch (err) {
      setError(handleApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSubFromDB = async (id, index) => {
  if (!window.confirm("Yakin ingin menghapus subkategori ini dari database?")) return;

  try {
    await axios.delete(`/admin/sub-categories/${id}`);
    handleRemoveSub(index);
  } catch (err) {
    alert("Gagal menghapus subkategori: " + handleApiError(err));
  }
};

  return (
    <div>
      {loading && <FullPageLoader />}

      <div className="card mt-24">
        <div className="card-header border-bottom">
          <h4 className="mb-4">Edit Category & SubCategory</h4>
        </div>
        <div className="card-body">
          {/* {error && <p style={{ color: "red" }}>{error}</p>} */}
          <ErrorModal error={error} onClose={() => setError("")} />

          <form onSubmit={handleSubmit}>
            <h3>Informasi Kategori</h3>
            <div className="row gy-4">
              <div className="col-sm-6 col-xs-6">
                <label className="form-label mb-8 h6">Category Name</label>
                <input
                  name="name"
                  className="form-control py-11"
                  placeholder="Enter Category Name"
                  value={form.name}
                  onChange={handleFormChange}
                  required
                />
              </div>
              <div className="col-sm-6 col-xs-6">
                <label className="form-label mb-8 h6">Slug (optional)</label>
                <input
                  name="slug"
                  className="form-control py-11"
                  placeholder="Slug (opsional)"
                  value={form.slug}
                  onChange={handleFormChange}
                />
              </div>
              <div className="col-sm-6 col-xs-6">
                <label className="form-label mb-8 h6">Prefix</label>
                <input
                  name="prefix"
                  className="form-control py-11"
                  placeholder="Prefix Kategori"
                  value={form.prefix}
                  onChange={handleFormChange}
                  required
                />
              </div>
            </div>

            <h3 className="mt-24">SubKategori</h3>
            <div className="row gy-4">
              {subcategories.map((sub, i) => (
                <div key={i} className="col-sm-6 col-xs-6">
                  <input
                    placeholder="Nama SubKategori"
                    value={sub.name}
                    onChange={(e) => handleSubChange(i, "name", e.target.value)}
                    required
                    className="form-control py-11 mb-2"
                  />
                  <input
                    placeholder="Prefix SubKategori"
                    value={sub.prefix}
                    onChange={(e) => handleSubChange(i, "prefix", e.target.value)}
                    required
                    className="form-control py-11 mb-2"
                  />
                  {sub.id ? (
                    <button
                        type="button"
                        className="btn py-9"
                        onClick={() => handleDeleteSubFromDB(sub.id, i)}
                        style={{ backgroundColor: "red", color: "white" }}
                    >
                        Hapus dari DB
                    </button>
                    ) : (
                    <button
                        type="button"
                        className="btn py-9"
                        onClick={() => handleRemoveSub(i)}
                        style={{ backgroundColor: "red", color: "white" }}
                    >
                        Hapus
                    </button>
                    )}
                  <hr />
                </div>
              ))}
            </div>

            <button type="button" className="btn btn-main py-9 mt-3" onClick={handleAddSub}>
              + Tambah SubKategori
            </button>
            <br /><br />

            <button className="btn btn-main py-9" type="submit">
              Simpan Perubahan
            </button>
            <Link to={`/admin/categories/${id}`}>
              <button className="btn btn-secondary py-9 mx-3">Kembali</button>
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
}
